import * as React from 'react';
import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import H4 from '@sdk/components/ui/typography/H4';
import Text14 from '@sdk/components/ui/typography/Text14';
import Href from '@sdk/components/ui/Href';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { FeatureNames } from '@web/account/types';

import useFeatureList from '../hooks/useFeatureList';

const Container = styled(Column)`
  background-color: ${({ theme }): string => theme.colors.white};
  align-items: center;
`;

const WrappedContent = styled(Row)`
  flex-wrap: wrap;
  width: 80%;
`;

const FeatureItem = styled(Row)`
  flex-basis: 33%;
  align-items: center;
`;

type Props = {
  hiddenKeys: FeatureNames[];
  user: AuthUserType;
  openPricingModal: () => void;
};
export const OtherPremiumFeatures: React.FC<React.PropsWithChildren<Props>> = ({
  hiddenKeys,
  user,
  openPricingModal,
}) => {
  const featureList = useFeatureList(user, hiddenKeys);

  return (
    <Container pTop={60} pBottom={60}>
      <Row pBottom={30}>
        <H4>{gettext('Other paid features')}</H4>
      </Row>
      <WrappedContent>
        {featureList.map(({ key, title, icon: Icon }) => (
          <FeatureItem key={key} pLeft={20} mTop={20}>
            <Icon />
            <Row pLeft={20}>
              <Text14 themeColor={ThemeColorType.gray}>{title}</Text14>
            </Row>
          </FeatureItem>
        ))}
      </WrappedContent>
      <Row pTop={30}>
        <Href onClick={openPricingModal} themeColor={ThemeColorType.primary}>
          {gettext('See pricing plans')}
        </Href>
      </Row>
    </Container>
  );
};
